/**
 * The small "latest activity" row of the project Home (components/home/WhatChanged.jsx, quiet state): the newest few things
 * that happened in the project, each as a short label and when, with where its details open. Pure: the events are
 * vfs-service's activity feed (services/CollabService.js getActivity), newest first.
 */
import { typeGroup } from './collab3Model';

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

/** What an event is called in one or two words: "Edited 3 files", "Deployed", "Shared"… Unknown types say their own summary. */
export function activityLabel(event) {
  const files = event?.files?.length || 0;
  switch (typeGroup(event?.type)) {
    case 'session': return files ? `Edited ${plural(files, 'file')}` : 'Edited';
    case 'agent-run': return files ? `AI edited ${plural(files, 'file')}` : 'AI edited';
    case 'revert': return 'Reverted a change';
    case 'publish': return event.type === 'deploy' ? 'Deployed' : 'Published';
    case 'version': return 'Published';
    case 'share': return 'Shared';
    case 'comment': return 'Comment';
    case 'mention': return 'Mention';
    case 'note': return 'Note';
    case 'handoff': return 'Handoff note';
    case 'suggestion': return 'Suggestion';
    case 'config': return 'Secrets changed';
    case 'mail': return 'Email';
    case 'data': return event.summary || 'Data changed';
    case 'origin': return event.summary || 'Created from a template';
    case 'pause': return 'Paused';
    default: return (event?.summary || event?.type || 'Activity').toString().slice(0, 40);
  }
}

/**
 * The newest `limit` kinds of activity, one per label (the latest of each, so ten edits are one "Edited" and the commit and
 * the deploy before them still show): `[{ key, label, at, event }]`, newest first.
 */
export function activityChips(events, limit = 4) {
  const seen = new Set();
  const chips = [];
  [...(events || [])]
    .filter((event) => event && event.at)
    .sort((a, b) => Date.parse(b.at) - Date.parse(a.at))
    .forEach((event) => {
      const label = activityLabel(event);
      if (seen.has(label) || chips.length >= limit) { return; }
      seen.add(label);
      chips.push({ key: event.id || `${event.type}-${event.at}`, label, at: event.at, event });
    });
  return chips;
}
